//
// Generated class EventPhaseItem
//

/// <reference path="EventPhaseItem_ManagedObject.ts" />

class EventPhaseItem extends EventPhaseItem_ManagedObject
{

}
